import { Expose } from 'class-transformer'

export class CampaignBookItemType {
  @Expose() bookId: number

  @Expose() bookTitle: string

  @Expose() bookPenFirstName: string

  @Expose() bookPublisherName: string

  // Per-chapter fields
  @Expose() chapterIdStart?: number

  @Expose() chapterIdEnd?: number

  @Expose() discountPricePerChapter?: number

  // Whole-story percentage
  @Expose() discountPercentage?: number

  // Whole-story coin price
  @Expose() originalPrice?: number

  @Expose() discountCoin?: number

  @Expose() discountedPrice?: number

  // Free-reading fields
  @Expose() dailyChapters?: number

  @Expose() freeDays?: number

  // Common
  @Expose() startDate?: string

  @Expose() endDate?: string
}
